/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_TitleInputs */



/**
* | output |
* | --- |
* | "Embed Audio" |
*
* @param {Audio_Embed_Export_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_title = /** @type {((inputs?: Audio_Embed_Export_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Intégrer l'audio")
	if (locale === "de") return /** @type {LocalizedString} */ ("Audio einbetten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Incorpora l'audio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Встроить аудио")
	if (locale === "es") return /** @type {LocalizedString} */ ("Insertar audio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("嵌入音频")
	if (locale === "ja") return /** @type {LocalizedString} */ ("音声を埋め込む")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो एम्बेड करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Incorporar áudio")
	return /** @type {LocalizedString} */ ("Embed Audio")
});